/**
 * Make Shortest Image height base for all three images
 */

window.addEventListener('load', function (e) {
  // const tripleImages = document.querySelectorAll('.js-section-triple-images .js-section__image-inner');

  // tripleImages.forEach(element => {
  //   for (let i = 0; i < tripleImages.length; i++) {
  //     const el = tripleImages[i];

  //     if (element.clientHeight > el.clientHeight) {
  //       element.parentElement.classList.add('is-taller');
  //     }
  //   }
  // });

  const sectionTripleImages = document.querySelectorAll('.js-section-triple-images');

  sectionTripleImages.forEach(el => {
    const images = el.querySelectorAll('.js-section__image-inner');

    images.forEach(image => {
      for (let i = 0; i < images.length; i++) {
        const el = images[i];

        if (image.clientHeight > el.clientHeight) {
          image.parentElement.classList.add('is-taller');
        }
      }
    });
  });
});
